import React from "react";
import { GroupsContent } from "../../../components/Groups/GroupsContent";
import { PageHeader } from "../../../components/shared/PageHeader/PageHeader";
import { tooltips } from "../../../lib/utils/tooltips";

export const GroupsMain = () => {
  return (
    <div className="GroupsMain">
      <PageHeader
        title="Groups"
        message={
          tooltips.groups?.groupsManagement ||
          "Manage user groups to organize access and permissions across workspace items."
        }
      />

      <GroupsContent />
    </div>
  );
};
